<template>
  <span :class="loaderClass" :style="loaderStyle"></span>
</template>

<script>
export default {
  name: 'Loader',
  props: {
    size: {
      type: String,
      default: '48px',
    },
    color: {
      type: String,
      default: '#FFF',
    },
  },
  computed: {
    loaderClass() {
      return 'loader';
    },
    loaderStyle() {
      return {
        width: this.size,
        height: this.size,
        borderColor: this.color,
        borderBottomColor: 'transparent',
      };
    },
  },
};
</script>

<style scoped>
.loader {
  border: 5px solid #fff;
  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// resources/js/app/components/Loader.vue